import { Severity } from '@sentry/types';
import core from '@gin-betting/core';
import { sentryHub } from '@gin-betting/core/dist/services';

const { appServiceLocator } = core;

let isFetched = false;
let minBet = 0;

// TODO: improvement to move minBet into the redux state (betslip)
export default function getMinBet() {
    if (isFetched) return minBet;

    isFetched = true;

    appServiceLocator
        .get('apiClient')
        .makeRequest({
            method: 'getMinBet',
            variables: {},
        })
        .then(response => {
            minBet = Number(response.data.minBet.value);
        })
        .catch(error => {
            sentryHub.withScope(scope => {
                scope.setLevel(Severity.Warning);
                scope.setExtras(error);
                scope.setTag('utils', 'utils:getMinBet');
                sentryHub.captureException('Failed to load minBet query');
            });
        });

    return minBet;
}
